import { Trans } from "@lingui/react/macro"
import { Loader, Text } from "@mantine/core"
import classes from "./styles.module.css"

/**
 * Dumb presentation of the "app is applying a waiting update" status — a
 * floating bottom-centred snackbar pill. The fixed positioning lives on a
 * plain wrapper `div` (NOT a Mantine component root) so nothing can override
 * it: the previous version styled an `<Alert>` root, whose position could
 * lose to Mantine's own styles and render the banner in-flow at the top,
 * overlapping the header.
 *
 * Storied separately from the smart `UpdatePrompt` (which owns the
 * service-worker lifecycle) so the pill's look is regression-covered across
 * brands/themes.
 */
export function UpdatePromptView(): React.JSX.Element {
  return (
    <div className={classes.wrap} role="status" aria-live="polite">
      <div className={classes.pill}>
        <Loader size={14} color="brand" />
        <Text size="sm" fw={500} className={classes.message}>
          <Trans>Updating…</Trans>
        </Text>
      </div>
    </div>
  )
}
